import { Link } from "react-router-dom";

export default function TourCard({ tour, colors, deleteTour }) {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6" key={tour.id}>
      <div className={`card border-${colors[0]} m-1 mt-3 height-180`}>
        <div className={`card-header bg-${colors[0]}`}>
          <div>
            عنوان تور:
            <span className="txt"> {tour.title} </span>
          </div>
        </div>
        <div className={`card-body bg-${colors[1]}`}>
          <div>
            تاریخ:
            <span className="txt"> {tour.duration} </span>
          </div>
          <div className="mt-2">
            {tour.transferType != "" ? (
              <>
                ترنسفر:
                <span className="txt"> {tour.transferType} </span>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          className={`card-footer bg-${colors[0]} d-flex justify-content-evenly`}
        >
          <Link
            to={`/tak-tour/${tour.id}`}
            data-bs-toggle="tooltip"
            title="مشاهده جزئیات"
            target="_blank"
          >
            <img
              alt="not found"
              src="/image/eye.svg"
              className="cursor-pointer"
            />
          </Link>
          <div data-bs-toggle="tooltip" title="حذف">
            <img
              alt="not found"
              src="/image/trash.svg"
              className="cursor-pointer"
              onClick={() => deleteTour(tour.id)}
            />
          </div>
          <Link
            to={`/admin-panel/create-tour/${tour.id}`}
            data-bs-toggle="tooltip"
            title="ویرایش"
            target="_blank"
          >
            <img
              alt="not found"
              src="/image/pencil-square.svg"
              className="cursor-pointer"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}
